module.exports = __webpack_public_path__ + "media/images/payments/payu-dark-f54fab7e266b3d1b390c4530b94d349c.svg";